import changeText from './_changeText'
import changeVideoSpeed from './_changeVideoSpeed'

export default () => {
  changeText()
  changeVideoSpeed()
}